import GENERATED_MUTATION_TYPES from './generated-checkout-mutation-types'
import CLIENT_MUTATION_TYPES from './basket-mutation-types'

export default {
  ...GENERATED_MUTATION_TYPES,
  ...CLIENT_MUTATION_TYPES,
}
